import {Button, Form, Input, Modal} from "antd";
import {useEffect, useRef} from "react";
import ModalCaptchaValidate from "./validate";

// 弹窗验证码
const ModalCaptcha = ({
                          open, onOk, onCancel, onCaptcha = f => f,
                          width = 300,
                          height = 150,
                          img = ""
                      }) => {

    const [form] = Form.useForm();
    const inputRef = useRef(null);

    useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [form, open]);

    // 聚焦焦点
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 500);
        }
    }, [open]);

    const handleOk = () => {
        form.validateFields().then(value => {
            onOk({code: value.code.trim()})
        }).catch(reason => console.log(reason))
    };

    const handleCancel = () => onCancel();

    return (
        <>
            <Modal title="请输入如下图形验证码" open={open} onOk={handleOk} onCancel={handleCancel}>
                <Form name="modalCaptcha" autoComplete="off" form={form} validateTrigger="onSubmit">
                    <Form.Item>
                        <div>
                            <img src={img} alt="图形验证码" style={{width: width + "px", height: height + "px"}}
                                 onClick={onCaptcha}/>
                            <Button type="link" onClick={onCaptcha}>看不清换一张</Button>
                        </div>
                    </Form.Item>

                    <Form.Item
                        label="验证码"
                        name="code"
                        rules={[
                            {required: true, message: '请输入图形验证码!'},
                            {validator: ModalCaptchaValidate.validateCaptcha}
                        ]}
                    >
                        <Input placeholder="图形验证码" ref={inputRef}/>
                    </Form.Item>
                </Form>

            </Modal>
        </>
    );
}

export default ModalCaptcha;
